<template>
  <div>
    <Layout v-if="sec_template">
      <Header>
        <HomeHeader ref="header"></HomeHeader>
      </Header>
      <Content :style="{'min-height':height+'px'}">
        <keep-alive>
          <router-view :key="activeDate" v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view :key="activeDate" v-if="!$route.meta.keepAlive" />
        <CoupleBack :cbModel="coupleBackModel" @cbModelChange="cbModelClose"></CoupleBack>
        <div class="right-fixed-btns">
          <!-- <div class="btn"><a :href="$store.state.index2_path + '/linkList'" target="_blank">产业<br />链接</a></div> -->
          <div class="btn"><a :href="$store.state.index2_path + '/Form/compContact'" target="_blank">企业<br />对接</a></div>
          <div class="btn"><a :href="$store.state.index_path + '/contact?type=1'" target="_blank">联系<br />合作</a></div>
          <div class="btn hover-show">
            <a>在线<br />客服</a>
            <div class="contact-ewm">
              <p><i class="iconfont">&#xe6e8;</i>扫码咨询在线客服</p>
              <img :src="$store.state.static_img_url+'pic/qiyeduijie.png'">
            </div>
          </div>
          <div class="btn"><a href="https://support.qq.com/products/606990" target="_blank">意见<br />反馈</a></div>
        </div>
        <BackTop class="home-top" v-if="!is_vbef"></BackTop>
      </Content>
      <home-footer v-if="footer_sec_template"></home-footer>
    </Layout>
    <div v-else>
      <keep-alive>
        <router-view :key="activeDate" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view :key="activeDate" v-if="!$route.meta.keepAlive" />
    </div>
    <Modal v-model="show_collect" :scrollable="true" :closable="false" :mask="false" :transfer="false" :footer-hide="true" class="collect-tip" width="273">
      <div class="cnt">
        <div class="tip">收藏成功，已收藏内容
          <br>在“我的-我的收藏”
          <br>可找到方便随时查看
        </div>
        <div class="btn">
          <div class="btn1" @click="handleClkNotAgain(1)">不再提示</div>
          <div class="btn2" @click="handleClkIKnow(1)">我知道了</div>
        </div>
      </div>
      <img :src="$store.state.static_img_url + 'pic/vbdata2.0/collet-model-bg.png'" />
    </Modal>
    <Modal class="collect__message" v-model="show_c_collect" title="提示" ok-text="知道了" cancel-text="关闭" @on-ok="ccollectOk">
      <p>亲，取消收藏后，不再记录该信息</p>
      <Checkbox v-model="no_c_again_show">不再提示</Checkbox>
    </Modal>
    <Modal v-model="show_atten" :scrollable="true" :closable="false" :mask="false" :transfer="false" :footer-hide="true" class="atten-tip" width="298">
      <div class="cnt">
        <div class="tip">关注成功，已关注的实体
          <br>在“产业智库-我的关注”可找到
          <br>还有更多维度数据供您查看
        </div>
        <div class="btn">
          <div class="btn1" @click="handleClkNotAgain(2)">不再提示</div>
          <div class="btn2" @click="handleClkIKnow(2)">我知道了</div>
        </div>
      </div>
      <img :src="$store.state.static_img_url + 'pic/vbdata2.0/atten-model-bg.png'" />
    </Modal>
    <AddApply ref="apply-try"></AddApply>
    <PreviewPic ref="preview-pic"></PreviewPic>
    <Contact ref="contact"></Contact>
    <VipPrompt :pageModal="page_modal" @pagecancel="pageShowOrCancel"></VipPrompt>
    <div class="apply-area" v-if="float_banner_list.length && apply_btn">
      <img class="apply-close" :src="$store.state.static_img_url+'pic/dongmai/close.png'" @click="closeApplyBtn">
      <a @click="globalClickBanner(float_banner_list[0])">
        <img :src="float_banner_list[0].img" :title="float_banner_list[0].description">
      </a>
    </div>
    <Modal v-model="fill_adv_status" v-if="fill_banner_list.length" :scrollable="true" :footer-hide="true" class-name="fill-adv-modal" width="540">
      <a @click="globalClickBanner(fill_banner_list[0])" class="fill-adv-image">
        <img :src="fill_banner_list[0].img" :title="fill_banner_list[0].description">
      </a>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment'
import Cookies from 'js-cookie'
import HomeHeader from '@/components/HomeHeader2.vue'
import HomeFooter from '@/components/HomeFooter2.vue'
import CoupleBack from '@/components/CoupleBack.vue'
// import GuidePage from '@/components/GuidePage.vue'
// VIP提示
import VipPrompt from '@/components/VipPrompt.vue'
import AddApply from '@/components/AddApply.vue'
import PreviewPic from '@/components/ssr/PreviewPic.vue'
import Contact from '@/components/ssr/Contact.vue'
import { addTryEnterPV, Aadvertisement, Ainsertrecords } from '@/service'
const sec_template_arr = [
  'BriefReport',
  'PreviewBriefReport',
  'Index',
  'Log',
  'About',
  'HelpCenter',
]
const footer_sec_template_arr = ['BuyVip']

export default {
  name: 'Home',
  provide() {
    return {
      reload: this.reload,
      login: this.login,
      selectIdentity: this.selectIdentity,
      showCollectMessage: this.showCollectMessage,
      showAttenMessage: this.showAttenMessage,
      showCCollectMessage: this.showCCollectMessage,
      loginVipFlow: this.loginVipFlow,
      handleShowVipPormpt: this.handleShowVipPormpt,
      is_vip: this.is_vip,
      haddleBackModel: this.haddleBackModel,
      getNewVersionInfo: this.getNewVersionInfo,
      haddleApplyTry: this.haddleApplyTry,
      haddleApplyTry2: this.haddleApplyTry2,
      globalhandlePreviewPic: this.handlePreviewPic,
      globalhandleContact: this.handleContact,
      globalClickBanner: this.globalClickBanner,
      globalInsertRecords: this.globalInsertRecords,
      handleClickProExperience: this.handleClickProExperience
    }
  },
  data() {
    return {
      height: 0,
      coupleBackModel: false,
      show_collect: false,
      show_atten: false,
      show_c_collect: false,
      no_c_again_show: true,
      activeDate: moment().unix(),
      which_guide: '',
      page_modal: false,
      apply_btn: true,
      fill_adv_status: false,
      float_banner_list: [],
      fill_banner_list: [],
    }
  },
  components: {
    HomeHeader,
    CoupleBack,
    HomeFooter,
    VipPrompt,
    AddApply,
    PreviewPic,
    Contact,
  },
  computed: {
    /**
     * 模板
     * true 有组件
     * false 无组件
     */
    sec_template: function () {
      return sec_template_arr.indexOf(this.$route.name) == -1 ? true : false
    },
    footer_sec_template: function () {
      return footer_sec_template_arr.indexOf(this.$route.name) == -1 ? true : false
    },
    user_key() {
      return this.$store.state.user_key
    },
    user() {
      return this.$store.state.user
    },
    is_vip() {
      let user_info
      if (this.user && typeof this.user == 'string') {
        user_info = JSON.parse(this.user)
        return user_info.db_vip == '1' || user_info.vip == '1'
      } else if (this.user && typeof this.user == 'object') {
        return this.user.db_vip == '1' || this.user.vip == '1'
      } else {
        return false
      }
    },
    router_name() {
      return this.$route.name
    },
    theme_switch() {
      return this.$store.state.theme_switch
    },
  },
  methods: {
    async addTryEnterPV(info_src) {
      let res = await addTryEnterPV(
        {
          info_src: info_src,
          userid: this.$store.state.user.id,
        },
        (error) => {
          this.$Message.error('请求错误！')
        }
      )
    },
    haddleApplyTry(title, summary, info_src) {
      this.$refs['apply-try'].title = title
      this.$refs['apply-try'].summary = summary
      this.$refs['apply-try'].info_src = info_src
      this.$refs['apply-try'].modelIndex = true
      // this.addTryEnterPV(info_src)
    },
    haddleApplyTry2(info_src) {
      // this.addTryEnterPV(info_src)
      let link = this.$store.state.index_path + '/applyTry?info_src=' + info_src
      window.open(link)
    },
    closeApplyBtn() {
      this.apply_btn = false
    },
    returnIndex() {
      // window.open("https://vcbeat.top/")
    },
    reload(cb) {
      this.activeDate = moment().unix()
      this.$nextTick(() => {
        if (cb) {
          cb
        }
      })
    },
    login(cb = null) {
      this.$refs['header'].showLogin(cb)
    },
    selectIdentity() {
      this.$refs['header'].selectIdentity()
    },
    cbModelClose(bl) {
      this.coupleBackModel = bl
    },
    haddleBackModel() {
      // this.coupleBackModel = !this.coupleBackModel
      window.open('https://support.qq.com/products/341861')
      // _czc.push(['_trackEvent', '动脉橙首页快讯', '意见反馈点击'])
    },
    getNewVersionInfo() {
      this.$refs['header'].getNewVersionInfo()
    },
    showCollectMessage() {
      this.show_collect = true
    },
    showAttenMessage() {
      this.show_atten = true
    },
    showCCollectMessage() {
      this.show_c_collect = true
    },
    ccollectOk() {
      if (this.no_c_again_show) {
        this.$store.commit('updateCCollectMessage', 0)
        localStorage.collect_c_message = 0
      }
      this.show_c_collect = false
    },
    loginVipFlow(cb) {
      //登录VIP流程
      if (this.user_key) {
        if (this.is_vip) {
          if (cb) {
            cb()
          }
        } else {
          this.pageShowOrCancel(true)
        }
      } else {
        this.login()
      }
    },
    pageShowOrCancel(page_modal) {
      this.page_modal = page_modal
    },
    handleShowVipPormpt() {
      this.page_modal = true
    },
    /**
     * 不再显示
     */
    handleClkNotAgain(index) {
      if (index == 1) {
        this.$store.commit('updateCollectMessage', 1)
        localStorage.collect_message = 1
        this.show_collect = false
      } else {
        this.$store.commit('updateAttenMessage', 1)
        localStorage.atten_message = 1
        this.show_atten = false
      }
    },
    handleClkIKnow(index) {
      if (index == 1) {
        this.show_collect = false
      } else {
        this.show_atten = false
      }
    },
    handlePreviewPic(url, type = 1, width = 'auto') {
      this.$refs['preview-pic'].imgUrl = url
      this.$refs['preview-pic'].imgType = type
      this.$refs['preview-pic'].show = true
      this.$refs['preview-pic'].imgWidth = width
    },
    handleContact() {
      this.$refs['contact'].modelIndex = true
    },
    globalClickBanner(item) {
      this.insertRecords(item)
      if (item.jumpType == 1) {
        window.open(item.jumpOrientation.pointUrl, '_blank')
      } else if (item.jumpType == 2) {
        this.handleContact()
      } else if (item.jumpType == 3) {
        this.handlePreviewPic(item.jumpOrientation.appletCode, 1, '200px')
      } else if (item.jumpType == 4) {
        if ([3, 4, 5].includes(item.jumpOrientation.serviceAppMiShowType)) {
          window.open(item.jumpOrientation.serviceAppMiUrl, '_blank')
        } else {
          let href =
            this.$store.state.index2_path + '/intelDetail/' + item.jumpOrientation.serviceAppMiId
          window.open(href, '_blank')
        }
      } else if (item.jumpType == 5) {
        let href =
          this.$store.state.index2_path + '/linkDetail/' + item.jumpOrientation.serviceAppLinkId
        window.open(href, '_blank')
      } else if (item.jumpType == 6) {
        let href = ''
        if (item.jumpOrientation.appEventType == 30) {
          href = this.$store.state.index2_path + '/eventCard/' + item.jumpOrientation.appEventId
        } else if (item.jumpOrientation.appEventType == 41) {
          href = this.$store.state.index2_path + '/reportCard/' + item.jumpOrientation.appEventId
        } else if (item.jumpOrientation.appEventType == 42) {
          href = this.$store.state.index2_path + '/companyCard/' + item.jumpOrientation.appEventId
        } else if (item.jumpOrientation.appEventType == 44) {
          href = this.$store.state.index2_path + '/productCard/' + item.jumpOrientation.appEventId
        } else if (item.jumpOrientation.appEventType == 43) {
          href = this.$store.state.index2_path + '/trackCard/' + item.jumpOrientation.appEventId
        } else if (item.jumpOrientation.appEventType == 27) {
          href = this.$store.state.index2_path + '/customCard/' + item.jumpOrientation.appEventId
        }
        window.open(href, '_blank')
      } else if (item.jumpType == 7) {
        const href = this.$store.state.index2_path + '/home/channelDetail/' + item.jumpOrientation.appChannelId
        window.open(href, '_blank')
      } else if (item.jumpType == 8) {
        const href = this.$store.state.index2_path + '/home/liveDetail/' + item.jumpOrientation.liveStreamsId
        window.open(href, '_blank')
      }
    },
    async insertRecords(item, viewType = 1) {
      let createTime = moment().format('YYYY-MM-DD HH:mm:ss')
      let params_arr = [
        {
          contentId: item.appAdScheduleId,
          contentType: 45,
          createTime: createTime,
          enterType: 23,
          imei: this.$store.state.uUid,
          loginPlatform: 1,
          viewType: viewType,
          xuserid: this.$store.state.uUserId,
        },
      ]
      let res = await Ainsertrecords({
        appAccessRecords: params_arr,
      })
    },
    async globalInsertRecords(item) {
      let createTime = moment().format('YYYY-MM-DD HH:mm:ss')
      let params_arr = [{
        ...item, 
        ...{
          createTime: createTime,
          xuserid: this.$store.state.uUserId,
          imei: this.$store.state.uUid,
          loginPlatform: 1,
        }
      }]
      let res = await Ainsertrecords({
        appAccessRecords: params_arr,
      })
    },
    async getHomeBanner() {
      let res = await Aadvertisement({ appAdPositionIds: [18, 34] })
      if (res.code == 0) {
        let arr = res.data || []
        this.float_banner_list = arr.filter((a) => a.adPositionId == 18)
        this.fill_banner_list = arr.filter((a) => a.adPositionId == 34)

        if(!this.fill_banner_list.length) return
        // 使用Moment.js获取当前日期并格式化为'YYYYMMDD'
        const current_date_str = moment().format('YYYYMMDD')
        // 检查cookie是否存在以及其值是否为当前日期
        const shouldUpdateCookie =
          !Cookies.get('open_fill_date') || Cookies.get('open_fill_date') != current_date_str
        // 如果需要更新cookie，则设置fill_adv_status为true并更新cookie的值
        if (shouldUpdateCookie) {
          this.fill_adv_status = true
          this.insertRecords(this.fill_banner_list[0], 2)
          Cookies.set('open_fill_date', current_date_str, {
            domain: this.$store.state.domain_path,
            path: '/',
            expires: this.$store.state.oneYearFromNow
          })
        }
      }
    },
    handleClickProExperience() {
      this.globalInsertRecords({
        content_type: 72,
        enter_type: 23,
        view_type: 1,
        keyword: '动脉智库'
      })
      if(!this.user_key) {
        this.login(this.handleClickProExperience)
        return
      }
      const href = this.$store.state.pro_path + '/home/index?experience=true'
      window.open(href, '_blank')
    },
  },
  created() {
    this.getHomeBanner()
  },
  mounted() {
    this.height = document.documentElement.clientHeight
    window.document.documentElement.setAttribute('data-theme', this.theme_switch ? 'light' : 'dark')
    // window.onresize = () => {
    //   this.height = document.documentElement.clientHeight - 40
    // }
    // this.showGuide(this.$route.name)
  },
  watch: {
    user_key(val) {
      if (val) {
        this.reload()
      }
    },
    router_name(val) {
      this.activeDate = moment().unix()
      // this.showGuide(val)
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
.collect-tip, .atten-tip
  color #000
  >>> .ivu-modal-wrap
    width 1200px
    left 50%
    bottom auto
    right auto
    margin-left -587px
    display flex
    justify-content flex-end
  >>> .ivu-modal
    margin 51px 0 0
    top auto
  >>> .ivu-modal-content
    background none
    box-shadow none
    border-radius 0
    .ivu-modal-body
      padding 0
      line-height 1
      font-size 0
      position relative
      .cnt
        position absolute
        width 168px
        top 36px
        left 0
        .tip
          color #fff
          font-size 14px
          line-height 22px
          text-align center
        .btn
          margin-top 15px
          display flex
          justify-content space-between
          padding 0 18px
          .btn1, .btn2
            width 60px
            height 32px
            border 1px solid #FFFFFF
            border-radius 6px
            font-size 12px
            color #FFFFFF
            display flex
            justify-content center
            align-items center
            cursor pointer
          .btn1
            &:hover
              background rgba(255, 255, 255, 0.1)
          .btn2
            background #FFFFFF
            color #FA5A00
            &:hover
              border-color rgba(255, 255, 255, 0.9)
              background rgba(255, 255, 255, 0.9)
      img
        width 273px
        height 168px
.atten-tip
  >>> .ivu-modal-wrap
    margin-left -340px
    justify-content flex-start
  >>> .ivu-modal-content
    .ivu-modal-body
      .cnt
        position absolute
        width 196px
        top 36px
        left auto
        right 0
        .btn
          padding 0 14px
          .btn1, .btn2
            width 80px
      img
        width 298px
.filter-blur
  filter blur(4px)
.ivu-layout-header
  line-height 1
  background-color #FFFFFF
  padding 0
  position fixed
  width 100%
  z-index 1001
  box-shadow 0px 1px 4px 0px rgba(14, 15, 20, 0.2)
.ivu-layout-content
  padding-top 64px
.home-top
  bottom 134px !important
  right 10px !important
  z-index 999
  & >>> .ivu-back-top-inner
    border 1px solid #eee
    border-radius 4px
    background-color #FFF
    box-shadow 0px 2px 8px 0px rgba(88, 115, 143, 0.1)
    width 50px
    height 50px
    transition all 0.2s
  & >>> i
    color #FA5A00
    padding 11px
    font-size 26px
  &:hover
    & >>> .ivu-back-top-inner
      border-color #FA5A00
    & >>> .ivu-icon-ios-arrow-up
      padding 10px !important
      width 48px
      height 48px
      font-size 12px
      line-height 14px
      text-align center
      &:before
        content '返回顶部' !important
.right-fixed-btns
  position fixed
  width 50px
  right 10px
  bottom 190px
  cursor pointer
  z-index 998
  .btn
    box-shadow 0px 2px 8px 0px rgba(88, 115, 143, 0.1)
    position relative
    &+.btn
      margin-top 6px
    > a
      display flex
      line-height 14px
      width 50px
      height 50px
      border 1px solid #eee
      border-radius 4px
      font-size 12px
      align-items center
      justify-content center
      cursor pointer
      transition all 0.3s
      background #fff
      color #FA5A00
      &:hover
        border-color #FA5A00
  .hover-show:hover
    .contact-ewm
      display block
.contact-ewm
  display none
  position absolute
  right 60px
  top 0
  width 136px
  height 140px
  background-color #fff
  box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.1)
  padding-top 12px
  text-align center
  font-size 0
  z-index 998
  p
    font-size 12px
    line-height 16px
    color #666
    i
      color #FC9C7C
      display inline-block
      vertical-align top
      margin-right 4px
  img
    margin-top 12px
    width 88px
    height 88px
.apply-area
  position fixed
  right 5px
  bottom 5px
  z-index 1001
  a
    width 140px
    height auto
    font-size 0
    display block
    img
      width 100%
      height 100%
  .apply-close
    position absolute
    top 4px
    right 4px
    cursor pointer
>>> .fill-adv-modal
  display flex
  align-items center
  justify-content center
  .ivu-modal
    top 0
    .ivu-modal-close
      .ivu-icon-ios-close
        font-size 25px
        background rgba(255, 255, 255, 0.4)
        border-radius 50%
        color #FFF
        position relative
        display flex
        align-items center
        justify-content center
        top 0
        transition all 0.2s
        &:hover
          background rgba(255, 255, 255, 0.5)
    .ivu-modal-content
      border-radius 0
      background-color transparent
      border-radius 0
    .ivu-modal-body
      padding 0
      font-size 0
      line-height 1
    .fill-adv-image
      display block
      img
        width 100%
</style>
